import { FC, useEffect } from 'react';
import EditorVideo from 'lowcode/components/EditorVideo';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { XIcon } from '@/components/XPower/svg';
import EditorImg from 'lowcode/components/EditorImg';

const Performance: FC = () => {
    const { t } = useLang(`xcode.performance`);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneA = AniContainer.create({
                asyncFromTo: [
                    ['#Performance .pc .svg', { scale: 80 }, { scale: 1 }, 2],
                    ['#Performance .pc .video', { scaleY: 1 }, { scaleY: 0.8 }, 1],
                    // 暂停
                    ['#Performance .pc .middle-central', { y: 100 }, { y: -100 }, 1],
                    ['#Performance .pc .middle-central .title', { opacity: 0 }, { opacity: 1 }, 1],
                    ['#Performance .pc .middle-central .font-desc', { opacity: 0 }, { opacity: 1 }, 1],
                ],
                asyncTimeLine: [0, 2, 1, 1],
                triggerElement: '#Performance',
                triggerHook: 1,
                offset: '50%',
                duration: '200%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene(sceneA);
        }
    }, []);

    return (
        <div className={styled.Performance} id="Performance">
            {/* pc样式 */}
            <div className="pc">
                <div className="sticky">
                    <div className="mask">
                        <EditorVideo
                            className="video"
                            autoPlay
                            loop
                            src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718171905383/%E5%85%89%E6%95%88.mp4"
                        />
                        <div className="svg">
                            <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719300328954/Subtract%20(1).png" />
                            {/* <XIcon /> */}
                        </div>
                    </div>
                </div>
                <div className="text">
                    <div className="middle-central">
                        <p className="title">{t('title')}</p>
                        <p className="font-desc">
                            {t.rich('desc', {
                                line: (text: string) => <span>{text}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
            {/* mobile样式 */}
            <div className="mobile">
                <div className="mobile_video">
                    <EditorVideo
                        className="video"
                        autoPlay
                        loop
                        src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718171905383/%E5%85%89%E6%95%88.mp4"
                    />
                    <div className="x">
                        <XIcon />
                    </div>
                </div>
                <div className="text">
                    <div className="middle-central">
                        <p className="title">{t('title')}</p>
                        <p className="font-desc">
                            {t.rich('desc', {
                                line: (text: string) => <span>{text}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Performance;
